// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/worth/play.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'worth.play',
	post: false,
	require: function(config, filter) { return sorted('worth.play', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('c.collection_value / c.collection_plays', sortReverse('worth.play', filter), sortPriority('worth.play', filter))
	}
}
